.content {
  min-width: 200px;
}
